export default __webpack_public_path__ + "static/media/bank1.3cbaf958.png";